import { render, staticRenderFns } from "./WarehouseUserPasswordReset.vue?vue&type=template&id=60510e5c&"
import script from "./WarehouseUserPasswordReset.vue?vue&type=script&lang=js&"
export * from "./WarehouseUserPasswordReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WarehouseUserPasswordReset.vue"
export default component.exports